import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import InternalLayout from 'src/layouts/internal';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// Settings
const IndexPage = lazy(() => import('src/pages/settings/app'));

// ----------------------------------------------------------------------

export const internalRoutes = [
  {
    path: 'settings',
    element: (
      <AuthGuard>
        <InternalLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </InternalLayout>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
    ],
  },
];
